import React, { Component } from 'react';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import classNames from 'classnames';
import _ from 'lodash';
import { Field } from 'redux-form';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { UI_HEIGHT } from '../Common/constants';
import DatePicker from '../Common/datePicker';
import InputField from '../Common/inputField';
import { Grid, Row, Col, Panel, Button, Table, Input } from 'react-bootstrap';
import { Link } from 'react-router';
import Spinner from '../../components/Widgets/spinner';
import { Translate, Localize } from 'react-redux-i18n';
//import {buttonStyle, marginTopStyle, centerStyle} from '../Common/style'

class InventoryRelocationFromInbound extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    };

    constructor() {
        super();
        this.state = {
            tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton,

            orderNum: 0,

            inventories: {
                rows: [],
                selectedRows: [],
                filters: {},
                sortColumn: null,
                sortDirection: null,
            },

            relocatedInventories: {
                rows: [],
                selectedRows: [],
                filters: {},
                sortColumn: null,
                sortDirection: null,
            }
        };

        this.handleResize = this.handleResize.bind(this);
    }

    componentDidMount() {
      console.log("7");
        window.addEventListener('resize', this.handleResize);
        const { currentInventoryRelocation } = this.props;
        if(currentInventoryRelocation) {
          this.props.fetchInventoryRelocationDetail(currentInventoryRelocation.WarehouseRelocation_id)
            .then(() => {
              this.props.fetchInventories();
            });
        }
        else
          this.props.fetchInventories();
    }

    componentDidUpdate() {
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    // Once inventories are ready, reset state.

    componentWillReceiveProps(nextProps) {
      if(nextProps.currentWarehouseReceive) {
        console.log("61");
        console.log(nextProps.currentWarehouseReceive);
      }
      if(nextProps.currentInventoryRelocationDetail && nextProps.currentInventoryRelocationDetail != this.props.currentInventoryRelocationDetail) {
        let orderNum = 0;
        let warehouse_Relocation_Line = nextProps.currentInventoryRelocationDetail.Warehouse_Relocation_Line;
        warehouse_Relocation_Line.map(relocation => {
          orderNum = Math.max(orderNum, relocation.Pairid);
        });
        orderNum = orderNum+1;
        const relocatedInventories = {...this.state.relocatedInventories, rows: nextProps.currentInventoryRelocationDetail.Warehouse_Relocation_Line };
        this.setState({ relocatedInventories, orderNum: orderNum });
      }
        if (nextProps.inventories && nextProps.inventories != this.props.inventories) {
            const inventories = {...this.state.inventories, rows: nextProps.inventories }
            this.setState({
                inventories: inventories
            });
        }
    }

    handleResize(e) {
        this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton });
    }

    // setInventoryToRelocate(e) {
    //     e.preventDefault();
    //     const { inventories, relocatedInventories, orderNum } = this.state;
    //     const inventoryToLocate = { ...inventories.selectedRows[0],
    //         Pairid: orderNum,
    //         WarehouseZone_id: inventories.selectedRows[0].WarehouseZone_id,
    //         WarehouseBin_id: inventories.selectedRows[0].WarehouseBin_id,
    //         Quantity: "-" + this.props.quantityValue
    //     };
    //
    //     const inventoryRelocated = { ...inventories.selectedRows[0],
    //         Pairid: orderNum,
    //         WarehouseZone_id: this.props.toZoneValue,
    //         WarehouseBin_id: this.props.toBinValue,
    //         Quantity: '+' + this.props.quantityValue
    //     }
    //
    //     const newRelocatedInventories = { ...relocatedInventories };
    //     const newInventories = { ...inventories };
    //     newRelocatedInventories.rows.push(inventoryToLocate)
    //     newRelocatedInventories.rows.push(inventoryRelocated)
    //
    //     // const index = _.findIndex(inventories.rows, { 'Vendor_id': inventories.selectedRows[0].Vendor_id });
    //     // if (index > -1) {
    //     //     newInventories.rows.splice(index, 1);
    //     // }
    //     // newInventories.selectedRows = [];
    //     this.setState({
    //         relocatedInventories: newRelocatedInventories,
    //         inventories: newInventories,
    //         orderNum: orderNum+1
    //     })
    // }

    cancelInventoryRelocation(e) {
        e.preventDefault();
        const { inventories, relocatedInventories } = this.state;
        const inventoryToCancel = { ...relocatedInventories.selectedRows[0] };
        const OrderID = relocatedInventories.selectedRows[0].Pairid;

        // const newRelocatedInventories = { ...relocatedInventories };

        let newRelocatedInventoriesRows = [ ...relocatedInventories.rows ];
        // let newInventoriesRows = [ ...inventories.rows ];
        // let newTargetInventoriesRows = [ ...targetInventories.rows ];

        let index = _.findIndex(newRelocatedInventoriesRows, { 'Pairid': OrderID });
        if (index > -1 && parseInt(newRelocatedInventoriesRows[index].Quantity) > 0 ) {
            newRelocatedInventoriesRows.splice(index, 1);
            index = _.findIndex(newRelocatedInventoriesRows, { 'Pairid': OrderID });
            newRelocatedInventoriesRows.splice(index, 1);
        } else if (index > -1) {
            newRelocatedInventoriesRows.splice(index, 1);
            index = _.findIndex(newRelocatedInventoriesRows, { 'Pairid': OrderID });
            newRelocatedInventoriesRows.splice(index, 1);
        }

        let newRelocatedInventories = { ...relocatedInventories, rows: newRelocatedInventoriesRows };

        newRelocatedInventories.selectedRows = [];
        this.setState({
            relocatedInventories: newRelocatedInventories,
        })
    }

    createRelocation(e) {
      e.preventDefault();
      if(this.props.currentInventoryRelocationDetail) {
        this.props.editInventoryRelocation(
          this.props.currentInventoryRelocationDetail.WarehouseRelocation_id,
          1,
          this.props.postingDate,
          this.props.note,
          Data.Selectors.getRows(this.state.relocatedInventories)
        );
      }
      else
        this.props.createInventoryRelocation(
          1,
          this.props.postingDate,
          this.props.note,
          Data.Selectors.getRows(this.state.relocatedInventories)
        );
    }

    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.

    // renderTable() {
    //     if (this.props.vendorIsLoading && !this.props.vendorError) return <Spinner/>
    //     else if (this.props.vendorError) return <ContentWrapper><div className="alert alert-danger">{this.props.vendorError}</div></ContentWrapper>
    //     else {
    //         // Parameters of the react-data-grid
    //
    //         const getRows = () => {
    //             return Data.Selectors.getRows(this.state.inventories);
    //         }
    //
    //         const getSize = () => {
    //             return getRows().length;
    //         }
    //
    //         const rowGetter = rowIdx => {
    //             var rows = getRows();
    //             return rows[rowIdx];
    //         }
    //
    //         // Handle the sortable function
    //
    //         const handleGridSort = (sortColumn, sortDirection) => {
    //             var inventories = {...this.state.inventories, sortColumn: sortColumn, sortDirection: sortDirection };
    //             this.setState({ inventories });
    //         }
    //
    //         const handleFilterChange = filter => {
    //             let newFilters = Object.assign({}, this.state.inventories.filters);
    //             if (filter.filterTerm) {
    //                 newFilters[filter.column.key] = filter;
    //             } else {
    //                 delete newFilters[filter.column.key];
    //             }
    //             const inventories = {...this.state.inventories, filters: newFilters }
    //             this.setState({ inventories });
    //         }
    //
    //         // Handle the row select function
    //
    //         const onRowSelect = rows => {
    //             const inventories = {...this.state.inventories, selectedRows: rows }
    //             this.setState({ inventories });
    //         }
    //
    //         //Custom Formatter component
    //
    //         const NameFormatter = React.createClass({
    //             render() {
    //                 if (this.props.value) return <span>{this.props.value.Name}</span>;
    //                 else return <span className="label label-danger">-</span>;
    //             }
    //         });
    //
    //         // Column difinition
    //
    //         const columns = [
    //             {
    //                 key: 'ProductName',
    //                 name: 'Name',
    //                 resizable: true,
    //                 sortable: true,
    //                 filterable: true
    //             },
    //             {
    //                 key: 'ProductNum',
    //                 name: 'No.',
    //                 resizable: true,
    //                 sortable: true,
    //                 filterable: true
    //             },
    //             {
    //                 key: 'ProductDescription',
    //                 name: 'Description',
    //                 resizable: true,
    //                 sortable: true,
    //                 filterable: true
    //             },
    //             {
    //                 key: 'ProductUnitOfMeasure',
    //                 name: 'Unit Of Measure',
    //                 resizable: true,
    //                 sortable: true,
    //                 filterable: true
    //             },
    //             {
    //                 key: 'Pallet',
    //                 name: 'Pallet',
    //                 resizable: true,
    //                 sortable: true,
    //                 filterable: true
    //             },
    //             {
    //                 key: 'BinAmount',
    //                 name: 'Bin Amount',
    //                 resizable: true,
    //                 sortable: true,
    //                 filterable: true
    //             },
    //             {
    //                 key: 'WarehouseZone_id',
    //                 name: 'Warehouse Zone id',
    //                 resizable: true,
    //                 sortable: true,
    //                 filterable: true
    //             },
    //             {
    //                 key: 'WarehouseBin_id',
    //                 name: 'Warehouse Bin id',
    //                 resizable: true,
    //                 sortable: true,
    //                 filterable: true
    //             },
    //             {
    //                 key: 'Batch_PONum',
    //                 name: 'Batch PONum',
    //                 resizable: true,
    //                 sortable: true,
    //                 filterable: true
    //             },
    //             {
    //                 key: 'ExpiredDate',
    //                 name: 'Expired Date',
    //                 resizable: true,
    //                 sortable: true,
    //                 filterable: true
    //             }
    //         ]
    //
    //         return (
    //             <Row><Col sm={ 12 }><div style={{ maxWidth: '99%' }}>
    //                 <ReactDataGrid
    //                     rowKey='id'
    //                     onGridSort={handleGridSort}
    //                     toolbar={<Toolbar enableFilter={true}/>}
    //                     onAddFilter={handleFilterChange}
    //                     columns={columns}
    //                     rowGetter={rowGetter}
    //                     rowsCount={getSize() }
    //                     minHeight={200}
    //                     enableRowSelect='single'
    //                     onRowUpdated={this.handleRowUpdated}
    //                     onRowSelect={onRowSelect} />
    //             </div></Col></Row>
    //         )
    //     }
    // }
    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.

    renderRelocatedTable() {
        if (this.props.vendorIsLoading && !this.props.vendorError) return <Spinner/>
        else if (this.props.vendorError) return <ContentWrapper><div className="alert alert-danger">{this.props.vendorError}</div></ContentWrapper>
        else {
            // Parameters of the react-data-grid

            const getRows = () => {
                return Data.Selectors.getRows(this.state.relocatedInventories);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var relocatedInventories = {...this.state.relocatedInventories, sortColumn: sortColumn, sortDirection: sortDirection };
                this.setState({ relocatedInventories: relocatedInventories });
            }

            const handleFilterChange = filter => {
                let newFilters = Object.assign({}, this.state.relocatedInventories.filters);
                if (filter.filterTerm) {
                    newFilters[filter.column.key] = filter;
                } else {
                    delete newFilters[filter.column.key];
                }
                const relocatedInventories = {...this.state.relocatedInventories, filters: newFilters }
                this.setState({ relocatedInventories: relocatedInventories });
            }

            // Handle the Dragable cell function

            const handleCellDrag = e => {
                let { relocatedInventories } = this.state
                let rows = relocatedInventories.rows.slice(0);
                for (let i = e.fromRow; i <= e.toRow; i++) {
                    let rowToUpdate = rows[i];
                    rowToUpdate[e.cellKey] = e.value;
                }
                const newRelocatedInventories = {...relocatedInventories, rows: rows }
                this.setState({
                    relocatedInventories: newRelocatedInventories
                });
            }

            // Handle the editable function

            const handleRowUpdated = e => {
                // merge updated row with current row and rerender by setting state
                let { relocatedInventories } = this.state
                let rows = getRows();//relocatedInventories.rows.slice(0);
                Object.assign(rows[e.rowIdx], e.updated);
                const newRelocatedInventories = {...relocatedInventories, rows: rows }
                this.setState({
                    relocatedInventories: newRelocatedInventories,
                });
            }

            // Handle the row select function

            const onRowSelect = rows => {
                const relocatedInventories = {...this.state.relocatedInventories, selectedRows: rows };
                this.setState({ relocatedInventories: relocatedInventories });
            }

            //Custom Formatter component

            const NameFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span>{this.props.value.Name}</span>;
                    else return <span className="label label-danger">-</span>;
                }
            });

            // Column difinition

            const columns = [
                {
                    key: 'ProductNum',
                    name: <Translate value="product_num" />,
                    resizable: true,
                    sortable: true,
                    width: 120,
                    filterable: true
                },
                {
                    key: 'ProductName',
                    name: <Translate value="name" />,
                    resizable: true,
                    sortable: true,
                    width: 90,
                    filterable: true
                },
                {
                    key: 'Quantity',
                    name: <Translate value="relocate_quantity" />,
                    resizable: true,
                    sortable: true,
                    width: 200,
                    filterable: true,
                    editable: true
                },
                {
                    key: 'WarehouseZone_id',
                    name: <Translate value="zone" />,
                    resizable: true,
                    sortable: true,
                    width: 200,
                    filterable: true,
                    editable: true
                },
                {
                    key: 'WarehouseBin_id',
                    name: <Translate value="bin" />,
                    resizable: true,
                    sortable: true,
                    width: 200,
                    filterable: true,
                    editable: true
                }
            ]

            return (
                <Row><Col sm={ 12 }><div style={{ maxWidth: '99%' }} id="InventoryRelocationFromInbound-dataGrid1">
                    <ReactDataGrid
                        rowKey='Pairid'
                        onGridSort={handleGridSort}
                        toolbar={<Toolbar enableFilter={true}/>}
                        onAddFilter={handleFilterChange}
                        columns={columns}
                        rowGetter={rowGetter}
                        rowsCount={getSize() }
                        minHeight={200}
                        enableRowSelect='single'
                        onCellsDragged={handleCellDrag}
                        enableCellSelect={true}
                        onRowUpdated={handleRowUpdated}
                        onRowSelect={onRowSelect} />
                </div></Col></Row>
            )
        }
    }


    render() {
        const { inventories, relocatedInventories } = this.state;
        return (
            <ContentWrapper>
                <div className="content-heading"><Translate value="inventory_relocation" /></div>
                <Row><Col sm={ 12 }>
                    <Link to="/inventories/relocation"  className="btn btn-green buttonStyle" ><em className="fa fa-mail-reply"/></Link>
                    <div className="pull-right">
                        <button
                          className="btn btn-primary buttonStyle"
                          onClick={(e) => this.createRelocation(e) }>
                          <em className="fa fa-save marginRightStyle" /><Translate value="save" /></button>
                    </div>
                </Col></Row>
              <Row className="marginTopStyle">
                    <Col sm={ 12 }>
                        <Panel header="Inventory Relocation Sheet | Warehouse Location">
                            <h4><Translate value="inventory_relocation_sheet" /></h4>
                            <hr/>
                            <p><Translate value="list_of_inventory_relocation_lines" /></p>
                            {this.renderRelocatedTable() }
                            <button
                                className="btn btn-warning pull-right marginTopStyle"
                                onClick={(e) => this.cancelInventoryRelocation(e) }
                                disabled={ !relocatedInventories.selectedRows[0] }><Translate value="cancel" /></button>
                        </Panel>
                    </Col>
                </Row>
                <Row>
                    <Col sm={ 7 }>
                        <Col sm={ 6 }><Translate value="relocation_date" />: </Col>
                        <Col sm={ 6 } className="marginBottomStyle">
                            <Field component={DatePicker} name="PostingDate"></Field>
                        </Col>
                        <Col sm={ 6 }><Translate value="modifier" />: </Col>
                        <Col sm={ 6 }>
                            <Field component={InputField} name="Modify_Username"></Field>
                        </Col>
                        <Col sm={ 3 }><Translate value="note" />: </Col>
                        <Col sm={ 9 }>
                            <Field name="Note" component="Textarea" className="form-control" style={{ minHeight: '100px' }}/>
                        </Col>
                    </Col>
                </Row>
                <br/>
            </ContentWrapper>
        );
    }
}



export default InventoryRelocationFromInbound;



// WEBPACK FOOTER //
// ./master/jsx/components/Inventories/inventoryRelocationFromInbound.jsx